<template>
  <div :id="'videoTile' + video.id" class="videoTile">
    <!-- <v-card dark class="rounded-0"> -->
    <video
      class="vid withShaddow"
      :id="video.id"
      width="100%"
      controls
      preload="metadata"
      :poster="video.poster"
    >
      <source :src="video.url" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      class="playbutton"
      :class="showClass"
      viewBox="0 0 100 100"
      @click="startPlay"
    >
      <!-- <g
        id="Group_27"
        data-name="Group 27"
        x="0"
        y="0"
      > -->
      <g
        id="Ellipse_10"
        data-name="Ellipse 10"
        fill="#fff"
        stroke="#707070"
        stroke-width="1"
        opacity="0.696"
      >
        <circle cx="50%" cy="50%" r="15%" stroke="none" />
        <circle cx="50%" cy="50%" r="15%" fill="none" />
      </g>

      <g id="pol" fill="#fff" stroke="#707070" stroke-width="1" opacity="0.696">
        <polygon
          id="pol"
          class="polygon"
          points="47,45 47,55 55,50"
          fill="#606060"
          stroke="#606060"
        />
      </g>

      <!-- </g> -->
      <!-- </g> -->
    </svg>

    <ul :id="'controls' + video.id" class="video-controls controls">
      <li>
        <button
          :class="iconplay"
          id="playpause"
          type="button"
          @click="playpause"
        ></button>
      </li>
      <li class="progress-li">
        <progress :id="'progress' + video.id" value="0" max="100">
          <span id="progress-bar"></span>
        </progress>
      </li>
      <li>
        <button
          id="mute"
          :class="iconmute"
          type="button"
          @click="mute"
        ></button>
      </li>
      <li>
        <button
          id="voldec"
          :class="iconquieter"
          type="button"
          @click="alterVolume('-')"
        ></button>
      </li>
      <li>
        <button
          id="volinc"
          :class="iconlouder"
          type="button"
          @click="alterVolume('+')"
        ></button>
      </li>
      <li>
        <button
          id="fs"
          :class="iconexpand"
          type="button"
          @click="toggleFullscreen"
        ></button>
      </li>
    </ul>
    <!-- </v-card> -->
  </div>
</template>

<script>
export default {
  name: "VideoTile",
  props: ["video"],
  data() {
    return {
      showClass: "showPlay",
      iconplay: "fas fa-play",
      iconmute: "fas fa-volume-mute",
      iconlouder: "fas fa-volume-up",
      iconquieter: "fas fa-volume-down",
      iconexpand: "fas fa-expand",
    };
  },
  computed: {
    getHeight() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 250 : 300;
    },
    getWidth() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 250 : 300;
    },
  },
  methods: {
    startPlay() {
      this.playpause();
    },
    playpause() {
      var current_video = document.getElementById(this.video.id);
      if (current_video.paused || current_video.ended) {
        current_video.play();
        this.showClass = "hidePlay";
      } else {
        this.showClass = "showPlay";
        current_video.pause();
      }
    },
    mute() {
      var current_video = document.getElementById(this.video.id);
      current_video.muted = !current_video.muted;
    },
    alterVolume(dir) {
      var current_video = document.getElementById(this.video.id);
      var currentVolume = Math.floor(current_video.volume * 10) / 10;
      if (dir === "+") {
        if (currentVolume < 1) current_video.volume += 0.1;
      } else if (dir === "-") {
        if (currentVolume > 0) current_video.volume -= 0.1;
      }
    },
    toggleFullscreen() {
      const vidid = "videoTile" + this.video.id;
      var videoContainer = document.getElementById(vidid);
      if (isFullScreen()) {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.webkitCancelFullScreen)
          document.webkitCancelFullScreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
        setFullscreenData(vidid, false);
      } else {
        if (videoContainer.requestFullscreen)
          videoContainer.requestFullscreen();
        else if (videoContainer.mozRequestFullScreen)
          videoContainer.mozRequestFullScreen();
        else if (videoContainer.webkitRequestFullScreen)
          videoContainer.webkitRequestFullScreen();
        else if (videoContainer.msRequestFullscreen)
          videoContainer.msRequestFullscreen();
        setFullscreenData(vidid, true);
      }
    },
  },
  created() {},
  mounted() {
    // Only setup custom video controls, if browser supports this!
    var supportsVideo = !!document.createElement("video").canPlayType;
    if (supportsVideo) {
      // var videoContainer = document.getElementById("videoContainer");

      // Hide the default controls
      var current_video = document.getElementById(this.video.id);
      current_video.controls = false;
      // Display the user defined video controls
      var videoControls = document.getElementById("controls" + this.video.id);
      videoControls.style.display = "block";

      //start progress tracking
      const progress = document.getElementById('progress' + this.video.id);
      current_video.addEventListener("timeupdate", function () {
        progress.value = current_video.currentTime;
      });
    }
  },
};

var isFullScreen = function () {
  return !!(
    document.fullscreen ||
    document.webkitIsFullScreen ||
    document.mozFullScreen ||
    document.msFullscreenElement ||
    document.fullscreenElement
  );
};
var setFullscreenData = function (vidid, state) {
  var videoContainer = document.getElementById(vidid);
  videoContainer.setAttribute("data-fullscreen", !!state);
};

// Progress bar update

//  progressBar.style.width = Math.floor((vid.currentTime / vid.duration) * 100) + '%';

// function progressLoop(prog, vid) {
//   setInterval(function () {
//     prog.value = Math.round(
//       (vid.currentTime / vid.duration) * 100
//     );
//   }, 5000);
// }
</script>

<style lang="scss" scoped>
.videoTile {
  z-index: 10;
  position: relative;

  .video-controls {
    visibility: hidden;
  }
  &:hover .video-controls {
    visibility: visible;
  }
}
.vid {
  object-fit: cover;
}

.video-controls {
  display: none;
  z-index: 2147483647;

  width: 100%;
  position: absolute;
  bottom: 0;
  padding-bottom: 10px;

  li {
    display: inline;
    padding-right: 10px;

    button {
      color: #fff;
      opacity: 0.5;

      &:hover {
        color: #e37d30;
        opacity: 0.9;
      }
    }
  }
}

.withShaddow {
  box-shadow: -26px 29px 13px -6px rgba(0, 0, 0, 0.6);
}

.playbutton {
  position: absolute;
  top: 0;
  left: 0;

  &:hover {
    cursor: pointer;

    #Ellipse_10 {
      stroke: #e37d30;
      opacity: 0.8;
    }

    #pol {
      stroke: #e37d30;
      fill: #e37d30;
      opacity: 0.8;
    }
  }
}

progress {
  // display: block;
  // width: 100%;
  // height: 81%;
  // margin-top: 0.125rem;
  // border: none;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;

  background-color: #fff;
  opacity: 0.5;

  #progess {
    background-color: #e37d30;
  }
}

progress::-webkit-progress-bar {
  background-color: #fff;
  opacity: 0.5;
}

progress::-webkit-progress-value {
  background-color: #e37d30;

  background: repeating-linear-gradient(
    -90deg,
    #fff,
    #fff 1px,
    #e37d30 2px,
    #e37d30 4px
  );
  /* style rules */
}

progress::-moz-progress-bar {
  background-color: #fff;
  opacity: 0.5;
}

progress::-moz-progress-value {
  background-color: #e37d30;

  background: repeating-linear-gradient(
    -90deg,
    #fff,
    #fff 1px,
    #e37d30 2px,
    #e37d30 4px
  );
  /* style rules */
}

// #progress {
//   background;
// }

.showPlay {
  opacity: 1;
}

.hidePlay {
  opacity: 0;
}
</style> 